import { ArrowLeftCircle, ArrowRightCircle } from 'lucide-react';

import { Button } from '../ui/button';

type CarouselArrowProps = {
  direction: 'left' | 'right';
  display?: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export function CarouselArrow(props: CarouselArrowProps) {
  const { onClick, display = true, direction, disabled } = props;

  if (!display) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className={`top-1/2 absolute z-50 ${direction === 'left' ? 'left-4' : 'right-4'}`}
      disabled={disabled}
    >
      <span>
        {direction === 'left' ? (
          <ArrowLeftCircle className="h-7 w-7" />
        ) : (
          <ArrowRightCircle className="h-7 w-7" />
        )}
      </span>
    </Button>
  );
}
